import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-card-container" }
const _hoisted_2 = { class: "renew-information" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info-value" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info-value bigger" }
const _hoisted_9 = { class: "payment-method" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex-column",
    style: _normalizeStyle({
      display: $props.showScreen ? 'flex' : 'none'
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan)
        ? (_openBlock(), _createBlock($setup["BenefitsCardPlanCard"], {
            key: 0,
            "benefits-card-plan": ($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan! as BenefitsCardPlan),
            "hide-controls": true,
            style: {"width":"fit-content"}
          }, null, 8 /* PROPS */, ["benefits-card-plan"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-total" }, "Total por colaborador", -1 /* HOISTED */)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-025, 2px)"} }, null, -1 /* HOISTED */)),
          _createElementVNode("p", _hoisted_4, "R$ " + _toDisplayString($setup.FormatUtils.money(($setup.reqRenewBenCardsPlanStore.getTotalValuePerUser() ?? 0))), 1 /* TEXT */)
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-total" }, "Colaboradores no plano", -1 /* HOISTED */)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-025, 2px)"} }, null, -1 /* HOISTED */)),
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getUserCount() ?? 0), 1 /* TEXT */)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
        _createVNode($setup["Divider"]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "info-total" }, "Total", -1 /* HOISTED */)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-025, 2px)"} }, null, -1 /* HOISTED */)),
          _createElementVNode("p", _hoisted_8, "R$ " + _toDisplayString($setup.FormatUtils.money($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getTotalPlanValue() ?? 0)), 1 /* TEXT */)
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-600, 48px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode($setup["PaymentMethodCard"], {
          "payment-methods": [{ type: $setup.PaymentMethodTypes.PIX }, { type: $setup.PaymentMethodTypes.TICKET }]
        }, null, 8 /* PROPS */, ["payment-methods"])
      ])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"height":"48px"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_11, [
      _createVNode($setup["CommonButton"], {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.reqRenewBenCardsPlanStore.currentScreen = $setup.ReqBenCardsRenewScreens.INITIAL)),
        type: "outlined",
        text: "Voltar",
        action: "secondary"
      }),
      _createVNode($setup["CommonButton"], {
        text: "Confirmar renovação",
        onClick: $setup.renewBenCardsPlan
      })
    ])
  ], 4 /* STYLE */))
}